(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionDetailController', DivisionDetailController);

    /* Added UIFormAccess
    DivisionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Division', 'Employee'];

    function DivisionDetailController($scope, $rootScope, $stateParams, previousState, entity, Division, Employee) {
    */
    DivisionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Division', 'Employee', 'UIFormAccess'];

    function DivisionDetailController($scope, $rootScope, $stateParams, previousState, entity, Division, Employee, UIFormAccess) {
        var vm = this;

        vm.division = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        vm.employees = Employee.query({divisionId: vm.division.id});

        var unsubscribe = $rootScope.$on('telestatApp:divisionUpdate', function(event, result) {
            vm.division = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
